import { render } from "./SignUp.vue?vue&type=template&id=51ef9506"
import script from "./SignUp.vue?vue&type=script&lang=ts"
export * from "./SignUp.vue?vue&type=script&lang=ts"
script.render = render

export default script